import sockette from 'sockette';

function index (ref) {
	var Component = ref.Component;
	var createElement = ref.createElement;

	return (function (Component) {
		function anonymous(props, context) {
			Component.call(this, props, context);
			this.ws = null;
		}

		if ( Component ) anonymous.__proto__ = Component;
		anonymous.prototype = Object.create( Component && Component.prototype );
		anonymous.prototype.constructor = anonymous;
		anonymous.prototype.componentDidMount = function componentDidMount () {
			var ref = this;
			var props = ref.props;
			var url = props.url;
			var getSocket = props.getSocket;
			this.ws = sockette(url, props);
			typeof getSocket === 'function' && getSocket(this.ws);
		};
		anonymous.prototype.shouldComponentUpdate = function shouldComponentUpdate () {
			return false;
		};
		anonymous.prototype.componentWillUnmount = function componentWillUnmount () {
			this.ws.close();
		};
		anonymous.prototype.render = function render () {
			return null;
		};

		return anonymous;
	}(Component));
}

export default index;
